import { URLParams } from "./interfaces/UrlParams";

export function redirect(url: string) {
  window.location.href = url;
}

export function createLink(url: string, params: { [key: string]: any }) {
  const urlObj = new URL(url);
  Object.keys(params)
    .filter((key) => params[key] !== undefined && params[key] !== null)
    .forEach((key) => urlObj.searchParams.append(key, params[key]));
  return urlObj.toString();
}

export const lowercaseKeys = (obj: any): any => {
  const entries = Object.entries(obj);

  return Object.fromEntries(
    entries.map(([key, value]) => [key.toLowerCase(), value])
  );
};

export const readParamsFromURL = (): URLParams => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramsObject = Object.fromEntries(urlParams.entries());
  const newParamsObject = lowercaseKeys(paramsObject);

  const { partner, instance, game, token, useruuid, sessionid, lang, jackpot, currency } =
    newParamsObject;

  return {
    partner,
    instance,
    game,
    token,
    userUuid: useruuid,
    sessionId: sessionid,
    lang,
    jackpot,
    currency
  };
};
